import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getAllCategory } from "../../redux/apiCall/categoryCall";
import axios from "axios";
import AdminFormLayout from "../components/AdminFormLayout";
import ButtonComponent from "../../components/ButtonComponent";
import ColorPalettePicker from "../components/ColorPalettePicker";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import {
  appendColors,
  appendImages,
  getAdminUploadHeaders,
} from "../../utils/adminApi";

const AddProduct = () => {
  const dispatch = useDispatch();
  const categories = useSelector((state) => state.category.categories);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getAllCategory());
  }, [dispatch]);

  const [formData, setFormData] = useState({
    name: "",
    description: "",
    images: [],
    price: "",
    categoryId: "",
    color: [],
  });

  const [colors, setColors] = useState([]);

  useEffect(() => {
    if (categories.length > 0) {
      setFormData((prev) => ({ ...prev, categoryId: categories[0]._id }));
    }
  }, [categories]);

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "images") {
      if (files.length > 5) {
        toast.error("You can upload a maximum of 5 images.");
        return;
      }
      setFormData((prev) => ({ ...prev, images: Array.from(files) }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleDescriptionChange = (value) => {
    setFormData((prev) => ({ ...prev, description: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.images.length === 0) {
      toast.error("Please select at least one image.");
      return;
    }

    const descriptionText = formData.description.replace(/<[^>]*>/g, "").trim();
    if (!descriptionText) {
      toast.error("Product description is required.");
      return;
    }

    try {
      const productData = new FormData();
      productData.append("name", formData.name);
      productData.append("description", formData.description);
      productData.append("price", formData.price);
      productData.append("categoryId", formData.categoryId);

      appendColors(productData, colors);
      appendImages(productData, formData.images);

      await axios.post(
        "https://api.michelbandalidesign.com/api/productsale",
        productData,
        { headers: getAdminUploadHeaders() }
      );

      toast.success("Product added successfully!");
      navigate("/admin");
    } catch (error) {
      toast.error("Error adding product. Please try again.");
    }
  };

  return (
    <AdminFormLayout title="Add Product" backTo="/admin" backLabel="Back to Products">
        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <div className="admin-form-group">
            <label htmlFor="name">Product Name</label>
            <input
              type="text"
              className="form-control admin-all-forms-inputs"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="admin-form-group">
            <label htmlFor="description">Product Description</label>
            <ReactQuill
              id="description"
              theme="snow"
              value={formData.description}
              onChange={handleDescriptionChange}
              className="admin-all-forms-inputs-quill"
            />
          </div>

          <div className="admin-form-group">
            <label htmlFor="price">Product Price</label>
            <input
              type="number"
              className="form-control admin-all-forms-inputs"
              name="price"
              min="0"
              step="0.01"
              value={formData.price}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="admin-form-group">
            <label htmlFor="images">Product Images (max 5)</label>
            <input
              type="file"
              className="form-control admin-all-forms-inputs"
              name="images"
              accept="image/*"
              onChange={handleInputChange}
              multiple
              required
            />
          </div>

          <div className="admin-form-group">
            <label>Product Colors</label>
            <ColorPalettePicker selected={colors} onChange={setColors} />
          </div>

          <div className="admin-form-group">
            <label>Product Category</label>
            <select
              className="form-select admin-all-forms-inputs"
              name="categoryId"
              value={formData.categoryId}
              onChange={(e) => setFormData({ ...formData, categoryId: e.target.value })}
              required
            >
              {categories.map((cat) => (
                <option key={cat._id} value={cat._id}>
                  {cat.name}
                </option>
              ))}
            </select>
          </div>

          <ButtonComponent type="submit">Add Product</ButtonComponent>
        </form>
    </AdminFormLayout>
  );
};

export default AddProduct;
